import { render, staticRenderFns } from "./TenderEditTabApprovals.vue?vue&type=template&id=fc10ab6a&"
import script from "./TenderEditTabApprovals.vue?vue&type=script&lang=js&"
export * from "./TenderEditTabApprovals.vue?vue&type=script&lang=js&"
import style0 from "./TenderEditTabApprovals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports